import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';

@Component({
    selector: 'app-create-view',
    templateUrl: './create-view.component.html',
    styleUrls: ['./create-view.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatError, MatButton]
})
export class CreateViewComponent implements OnInit {

  public name = new UntypedFormControl('');

  constructor(private dialogRef: MatDialogRef<CreateViewComponent>) {
  }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    this.dialogRef.close(this.name.value);
  }

}
